import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LogoWithHomeLink from "../../../components/LogoWithHomeLink";
import SitePageLeftHeading from "../../../components/SitePageLeftHeading";
import SiteRightContent from "../../../components/SiteRightContent";

export default function Status() {
  const { state } = useLocation();
  const { t } = useTranslation();
  const contentUrl = import.meta.env.VITE_CONTENT_URL;

  const data = state?.data;

  return (
    <>
      <Helmet>
        <title>{t("pages.registration.status.title")}</title>
      </Helmet>

      <div className="flex flex-col flex-1 w-full lg:w-1/2">
        <LogoWithHomeLink />

        <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
          <SitePageLeftHeading
            title={t("pages.registration.status.page_title")}
            description={t("pages.registration.status.description")}
          />

          <div class="p-5 mb-6 border border-gray-200 rounded-2xl dark:border-white-500 lg:p-6">
            <div class="flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between">
              <div class="flex flex-col items-center w-full gap-6 xl:flex-row">
                <div class="w-20 h-20 overflow-hidden border border-gray-200 rounded-full dark:border-gray-800">
                  <img src={contentUrl + data.image} alt="user" />
                </div>
                <div class="order-3 xl:order-2">
                  <h4 class="mb-2 text-lg font-semibold text-center text-gray-800 dark:text-white/90 xl:text-left">
                    {data.firstName + " " + data.lastName}
                  </h4>
                  <div class="flex flex-col items-center gap-1 text-center xl:flex-row xl:gap-3 xl:text-left">
                    <p class="text-sm text-gray-500 dark:text-gray-400">
                      {data.email}
                    </p>
                    <div class="hidden h-3.5 w-px bg-gray-300 dark:bg-gray-700 xl:block"></div>
                    <p class="text-sm text-gray-500 dark:text-gray-400">
                      {data.mobile}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-5 mb-6 border border-gray-200 rounded-2xl dark:border-white-500 lg:p-6">
            <div class="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
              <div>
                <h4 class="text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-6">
                  {t("pages.registration.status.status")}
                </h4>

                <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-7 2xl:gap-x-32">
                  <span class="inline-flex items-center justify-center gap-1 rounded-full bg-blue-light-500 px-2.5 px-5 py-1 font-medium text-white">
                    In Review
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="p-5 mb-6 border border-gray-200 rounded-2xl dark:border-white-500 lg:p-6">
            <div class="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
              <div>
                <h4 class="text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-6">
                  {t("pages.registration.status.personal_info")}
                </h4>

                <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-7 2xl:gap-x-32">
                  <div>
                    <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      {t("pages.registration.status.id_number")}
                    </p>
                    <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                      {data.idNumber}
                    </p>
                  </div>

                  <div>
                    <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      {t("pages.registration.status.address")}
                    </p>
                    <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                      {data.address}
                    </p>
                  </div>

                  <div>
                    <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      {t("pages.registration.status.city")}
                    </p>
                    <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                      {data.city}
                    </p>
                  </div>

                  <div>
                    <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
                      {t("pages.registration.status.date_of_birth")}
                    </p>
                    <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                      {data.dateOfBirth}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SiteRightContent />
    </>
  );
}
